<template>
    <tr>
        <td>{{ expense.employee.name }}</td>
        <td>{{ expense.expense_date | date }}</td>
        <td>£{{ expense.expense_amount | money }}</td>
        <td
            class="expense-status"
            :class="expense.status.toLowerCase()"
        >
            {{ expense.status }}
        </td>
        <td>
            <span v-if="expense.reviewer">{{ expense.reviewer.name }}</span>
            <span v-else>-</span>
        </td>
        <td class="text-right">
            <activity-log
                v-if="expense.id"
                :id="expense.id"
                model="EmployeeExpense"
                small
            />

            <button
                class="btn btn-primary btn-sm"
                @click="review"
            >
                Review
            </button>
        </td>
    </tr>
</template>
<script>
export default {
    props: {
        expense: {
            required: true,
            type: Object,
        }
    },
    methods: {
        review () {
            this.$emit('review');
        }
    }
}
</script>
<style scoped lang="scss">
.expense-status {
    &.pending {
            color: #f5b235;
        }
        &.declined {
            color: #f53535;
        }
        &.approved {
            color: rgb(122, 201, 20)
        }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/expenses/RowComponent.vue